export const nullOption = label => ({
  label,
  value: null,
})
